// 认证调试工具
export class AuthDebugger {
  private static isEnabled = process.env.NODE_ENV === 'development';

  static logAuthChange(source: string, action: string, data: any) {
    if (!this.isEnabled) return;

    console.group(`🔐 [AUTH DEBUG] ${source} - ${action}`);

    if (data.tokens) {
    }

    if (data.user) {
    }

    console.groupEnd();
  }

  static logConflict(oidcData: any, graphqlData: any) {
    if (!this.isEnabled) return;

    console.group('⚠️  [AUTH CONFLICT DETECTED]');
    console.groupEnd();
  }

  static logDecision(decision: string, reason: string, context: any) {
    if (!this.isEnabled) return;
  }

  static validateUserObject(user: any, source: string): boolean {
    if (!this.isEnabled) return true;

    const isValid = !!(user?.email && (user?.firstName || user?.lastName || user?.displayName));

    if (!isValid) {
    } else {
    }

    return isValid;
  }

  static analyzeToken(token: string, type: string): any {
    if (!this.isEnabled || !token) return null;

    try {
      // 简单的JWT解析（仅用于调试）
      const parts = token.split('.');
      if (parts.length !== 3) return null;

      const payload = JSON.parse(atob(parts[1]));
      const now = Math.floor(Date.now() / 1000);

      const analysis = {
        issuer: payload.iss,
        subject: payload.sub,
        audience: payload.aud,
        expiresAt: payload.exp,
        issuedAt: payload.iat,
        tokenUse: payload.token_use,
        isExpired: payload.exp && payload.exp < now,
        timeToExpiry: payload.exp ? payload.exp - now : null,
        email: payload.email,
        scope: payload.scope,
      };

      return analysis;
    } catch (error) {
      return null;
    }
  }
}
